import { numberWithCommas, openInNewTab } from 'helpers';
import styles from './AudioGraph.module.css';
import cn from 'classnames';
import { MiniLineChart, assets } from '@round/whitelabel-ui';
import moment from 'moment';
import { Tooltip } from '@round/whitelabel-ui';
import { Point } from '@round/whitelabel-ui';

const { Audio: AudioIcon, Warning: WarningIcon } = assets;
type Props = {
    audioUrl?: string;
    points: Point[];
    shouldDisplayTimeSeriesData: boolean;
    isTimeSeriesLoading: boolean;
    lineColor?: string;
    hasError?: boolean;
    onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const AudioGraph = ({
    audioUrl,
    points,
    shouldDisplayTimeSeriesData,
    isTimeSeriesLoading,
    lineColor = '#2A94FF',
    hasError,
    onClick,
}: Props) => {
    const Icon = hasError ? WarningIcon : AudioIcon;

    return (
        <Tooltip.Root>
            {(anchor, setRef) => (
                <>
                    <div
                        ref={setRef}
                        className={cn(styles.dailyChangeContainer, { [styles.pointer]: !!audioUrl })}
                        onClick={(e) => {
                            if (onClick) {
                                onClick(e);
                                return;
                            }
                            // todo: remove after audio modals release
                            if (!audioUrl) {
                                return;
                            }

                            e.stopPropagation();
                            openInNewTab(audioUrl);
                        }}
                    >
                        <Icon
                            title="See audio info"
                            className={cn(styles.audioIcon, { [styles.errorIcon]: hasError })}
                        />

                        <div className={styles.chartContainer}>
                            <MiniLineChart
                                flatLineOnEmpty
                                lineColor={lineColor}
                                points={points}
                                renderTooltip={
                                    shouldDisplayTimeSeriesData
                                        ? (tooltipItem) => (
                                              <>
                                                  <Tooltip.Title>
                                                      {moment(tooltipItem.x).format('D MMM YYYY')}
                                                  </Tooltip.Title>
                                                  <Tooltip.Body>
                                                      <dl className={styles.chartTooltipStats}>
                                                          <div className={styles.chartTooltipStatsItem}>
                                                              <dt>Posts growth</dt>
                                                              <dd>{numberWithCommas(tooltipItem.y)}</dd>
                                                          </div>
                                                      </dl>
                                                  </Tooltip.Body>
                                              </>
                                          )
                                        : undefined
                                }
                                isLoading={isTimeSeriesLoading}
                            />
                        </div>
                    </div>

                    <Tooltip anchorElement={anchor} disabled={!hasError}>
                        <Tooltip.Title>Failed to load data</Tooltip.Title>
                    </Tooltip>
                </>
            )}
        </Tooltip.Root>
    );
};

export default AudioGraph;
